import { useState } from "react";
import { useLookupDonationsQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import type { Fond } from "../../types/Fond";
import Pager from "../Common/Pager";
import AppelListItem from "./AppelListItem";

function AppelsList(){
    const [params,setParams]=useState<Record<string, string>>({
        page:"0"
    });
    const {data:fonds, error, isLoading}=useLookupDonationsQuery(params);
    const {translate}=useTrads();
    const setPage=function(page:number){
        setParams({...params,page: page.toString()})
    }
    console.log(fonds);
    return (
            error ? (
               <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : fonds ? (
                <div>
                {fonds.data.map((fond:Fond)=>{return <div key={fond.id}> <AppelListItem  fond={fond} /> </div>})}
                <Pager curpage={fonds.page} totalpages={fonds.pages} setter={setPage}></Pager>
                </div>
            ):null
    )


}
export default AppelsList;